import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';

export interface ReportBuilderConfig {
  id?: string;
  enabled?: boolean;
}

const observerCreator = ({ actions }) => {
  const { fetchError, fetchRequestError, fetchSuccess } = actions;

  return ({ dispatch }) => ({
    onFetchSuccess(payload) {
      dispatch(fetchSuccess(payload));
    },
    onFetchError(error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    },
  });
};

const reportBuilderConfigResource = createDocumentResource<ReportBuilderConfig>({
  name: 'reportBuilderConfig',
  endpoint: 'v1/orgs/:orgId/configuration/report-builder',
  observerCreator,
});

export default reportBuilderConfigResource;
